import React, { useState } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { Stripboard } from '../../../app/entities/stripboard';

import styles from './renumber-shots.dialog.module.scss';
type RenumberShotsDialogProps = {
  stripboard: Stripboard;
  onCancel: () => void;
};

export const RenumberShotsDialog: React.FC<RenumberShotsDialogProps> = ({
  stripboard,
  onCancel,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const onHandleConfirm = async () => {
    setIsLoading(true);

    try {
      await stripboard.renumberShots();
    } finally {
      onCancel();
    }

    setIsLoading(false);
  };

  return (
    <Dialog
      title="Renumber shots"
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          key="re-number"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={onHandleConfirm}
          text="Yes, confirm"
        />,
      ]}
    >
      <p className={styles['content']}>
        Reorder Shot List numbering to become the new source of truth, to match the visuals of the
        Storyboard.
      </p>
    </Dialog>
  );
};
